import React from 'react';
import PropTypes from 'prop-types';
import { SimpleSelect } from 'react-selectize-advizr';
import styled from 'styled-components';
import LoadingMask from './LoadingMask';

export const getHeight = size => {
  switch (size) {
    case 'small':
      return '35px';
    default:
      return '45px';
  }
};

export const StyledSelect = styled(SimpleSelect)`
  width: 100%;

  && .react-selectize-placeholder {
    font-size: 16px;
    color: #979797;
    font-style: normal;
    width: 85%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ${props =>
    props.disabled
      ? `
        && .react-selectize-control .react-selectize-search-field-and-selected-values {
          background: rgba(0, 0, 0, 0.1);
          border: 1px solid #cac8c8;
        }
      `
      : ''}

  .react-selectize-control .react-selectize-search-field-and-selected-values {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    border: ${props =>
      props.disabled ? '1px solid rgb(230, 230, 230)' : '1px solid rgb(202, 200, 200)'};
    border-radius: 0;
    line-height: ${({ size }) => getHeight(size)};
    height: ${({ size }) => getHeight(size)};
    width: 100%;
    box-sizing: border-box;

    &:hover {
      border: ${props =>
        props.disabled ? '1px solid rgb(230, 230, 230)' : '1px solid rgb(202, 200, 200)'};
    }

    .value-wrapper {
      line-height: ${({ size }) => getHeight(size)};
      min-height: ${({ size }) => getHeight(size)};
      font-size: 16px;
      text-align: left;
      color: ${props => (props.disabled ? 'rgb(230, 230, 230)' : 'inherit')};
    }
  }

  .dropdown-menu {
    border: 1px solid rgb(202, 200, 200);
  }

  &.react-selectize {
    display: block;

    &::after {
      display: none;
    }
  }
`;

const FormikSelect = ({ options, field, form, ...props }) => {
  const handleOnChange = option => {
    if (option) {
      form.setFieldValue(field.name, option.value);
    }
  };

  return (
    <StyledSelect
      {...field}
      {...props}
      value={options.find(option => option.value === field.value)}
      onValueChange={handleOnChange}
      options={options}
    />
  );
};

FormikSelect.defaultProps = {
  size: 'normal',
};

FormikSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  size: PropTypes.oneOf(['small', 'normal']),
};

FormikSelect.LoadingMask = styled(LoadingMask)`
  width: 100%;
  height: 45px;
`;

export default FormikSelect;
